export const modalTitle = (action: string, context?: string | null) => (context ? `${action} — ${context}` : action)

export const gameTeamsLabel = (homeTeamName: string, awayTeamName: string) => `${homeTeamName} vs ${awayTeamName}`
